export default [
  {
    path: "/asset",
    name: "Asset",
    component: () => import("@/views/Asset/Asset"),
    meta: { title: "资产" },
  },
  {
    path: "/fundTransfer",
    name: "fundTransfer",
    component: () => import("@/views/Asset/fundTransfer"),
    meta: { title: "闪兑", keepAlive: true },
  },
  {
    path: "/fundTransferInfo",
    name: "fundTransferInfo",
    component: () => import("@/views/Asset/fundTransferInfo"),
    meta: { title: "闪兑历史" },
  },
  {
    path: "/fundTransferDetails",
    name: "fundTransferDetails",
    component: () => import("@/views/Asset/fundTransferDetails"),
    meta: { title: "闪兑详情" },
  },
  {
    path: "/fundTransferSelect",
    name: "fundTransferSelect",
    component: () => import("@/views/Asset/fundTransferSelect"),
    meta: { title: "闪兑货币选择" },
  },
  {
    path: "/withdraw",
    name: "Withdraw",
    component: () => import("@/views/Asset/Withdraw"),
    meta: { title: "提现" },
  },
  {
    path: "/withdrawInfo",
    name: "WithdrawInfo",
    component: () => import("@/views/Asset/WithdrawInfo"),
    meta: { title: "提币历史" },
  },
  {
    path: "/depositmothod",
    name: "depositmothod",
    component: () => import("@/views/Asset/depositmothod"),
    meta: { title: "充值" },
  },
  {
    path: "/withdrawalmethod",
    name: "withdrawalmethod",
    component: () => import("@/views/Asset/withdrawalmethod"),
    meta: { title: "提现" },
  },
  {
    path: "/recharge",
    name: "Recharge",
    component: () => import("@/views/Asset/Recharge"),
    meta: { title: "充值" },
  },
  {
    path: "/rechargeGift",
    name: "RechargeGift",
    component: () => import("@/views/Asset/RechargeGift"),
    meta: { title: "充值福利" },
  },
  {
    path: "/rechargeSelect",
    name: "RechargeSelect",
    component: () => import("@/views/Asset/RechargeSelect"),
    meta: { title: "充值货币" },
  },
  {
    path: "/withdrawSelect",
    name: "withdrawSelect",
    component: () => import("@/views/Asset/withdrawSelect"),
    meta: { title: "提现货币" },
  },
  {
    path: "/rechargeInfo",
    name: "RechargeInfo",
    component: () => import("@/views/Asset/RechargeInfo"),
    meta: { title: "充值历史" },
  },
  {
    path: "/collection",
    name: "collection",
    component: () => import("@/views/Asset/collection"),
    meta: { title: "收款方式" },
  },
  {
    path: "/addCollection",
    name: "addCollection",
    component: () => import("@/views/Asset/addCollection"),
    meta: { title: "添加收款方式" },
  },
  {
    path: "/fiatCurrency",
    name: "fiatCurrency",
    component: () => import("@/views/Asset/fiatCurrency"),
    meta: { title: "法币" },
  },
  {
    path: "/rechargeFiat",
    name: "rechargeFiat",
    component: () => import("@/views/Asset/rechargeFiat"),
    meta: { title: "法币充值" },
  },
  {
    path: "/fiatCurrencyPayment",
    name: "fiatCurrencyPayment",
    component: () => import("@/views/Asset/fiatCurrencyPayment"),
    meta: { title: "付款" },
  },
  {
    path: "/fiatCurrencyBehalf",
    name: "fiatCurrencyBehalf",
    component: () => import("@/views/Asset/fiatCurrencyBehalf"),
    meta: { title: "支付" },
  },
  {
    path: "/fiatCurrencyHistory",
    name: "fiatCurrencyHistory",
    component: () => import("@/views/Asset/fiatCurrencyHistory"),
    meta: { title: "法币历史", keepAlive: true },
  },
  {
    path: "/fiatCurrencyInfo",
    name: "fiatCurrencyInfo",
    component: () => import("@/views/Asset/fiatCurrencyInfo"),
    meta: { title: "订单详情" },
  },
];



// WEBPACK FOOTER //
// ./src/router/config/AssetRouter.js